import { render } from "./WindowControl.vue?vue&type=template&id=884d2bda"
import script from "./WindowControl.vue?vue&type=script&lang=js"
export * from "./WindowControl.vue?vue&type=script&lang=js"

import "./WindowControl.vue?vue&type=style&index=0&id=884d2bda&lang=css"

import exportComponent from "/vercel/path0/sun-motion-visualization/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__